import React from 'react'
import PropTypes from 'prop-types'
import FilterInput from "../../../customers/components/filters/FilterInput"
import {TreeSelect} from "antd"

UserFilters.propTypes = {
    userName: PropTypes.string,
    fullName: PropTypes.string,
    deptId: PropTypes.any,
    treeData: PropTypes.array,
    onChangeInput: PropTypes.func.isRequired,
    onChangeDepartment: PropTypes.func.isRequired
}

function UserFilters(props) {
    const {userName, fullName, deptId, treeData, onChangeInput, onChangeDepartment} = props

    const _handleChange = (value) => {
        if (typeof onChangeDepartment === 'function') {
            onChangeDepartment(value)
        }
    }

    return (
        <div className="PageFilters">
            <FilterInput
                label="UserName"
                name="userName"
                placeholder="Search userName..."
                value={userName}
                onChangeInput={onChangeInput}
            />

            <FilterInput
                label="FullName"
                name="fullName"
                placeholder="Search fullName..."
                value={fullName}
                onChangeInput={onChangeInput}
            />

            <div className="FilterSelect">
                <label>Phòng ban</label>
                <TreeSelect
                    style={{width: '100%'}}
                    value={deptId}
                    dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                    treeData={treeData}
                    placeholder="Please select"
                    treeDefaultExpandAll
                    showSearch
                    filterTreeNode={(search, item) => {
                        return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0;
                    }}
                    onChange={_handleChange}
                />
            </div>
        </div>
    )
}

export default UserFilters